import { ROOM_MEMBER } from "src/constants/matrixEventTypes";
/**
 * 
 * Filters a room's timeline to only include events during the user's membership periods.
 * @param {import('matrix-js-sdk').Room} room
 * @param {Array} timeline
 * @param {string} userId
 * @returns {Array} filtered events
 */
export function getFilteredTimelineForUser(room, timeline, userId) {
    if (!room) return timeline;

    const membershipEventsTimeline = room.getUnfilteredTimelineSet()
        .getLiveTimeline()
        .getEvents()
        .filter(e => e.getType() === ROOM_MEMBER && e.getStateKey() === userId);

    if (membershipEventsTimeline.length === 0) return timeline;

    const membershipPeriods = [];
    let lastJoinTs = null;

    membershipEventsTimeline.forEach(event => {
        const membership = event.getContent()?.membership;
        const ts = event.getTs();

        if (membership === "join") lastJoinTs = ts;
        else if (membership === "leave" && lastJoinTs) {
            membershipPeriods.push({ start: lastJoinTs, end: ts });
            lastJoinTs = null;
        }
    });

    if (lastJoinTs) membershipPeriods.push({ start: lastJoinTs, end: Infinity });

    return timeline.filter(event => {
        const ts = event.getTs();
        const relatesTo = event.getContent()?.["m.relates_to"];
        const isReplacement = relatesTo?.rel_type === "m.replace";
        if (isReplacement) return false;

        return membershipPeriods.some(period => ts >= period.start && ts <= period.end);
    });
}
